import { Sparkles } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { format } from 'date-fns';

interface AIEnrichedBadgeProps {
  enrichedAt?: string | null;
  className?: string;
  size?: 'sm' | 'default';
}

export function AIEnrichedBadge({ enrichedAt, className = '', size = 'default' }: AIEnrichedBadgeProps) {
  // If no enrichedAt provided, show badge without tooltip (for simple indicator use)
  const sizeClasses = size === 'sm' ? 'text-[10px] px-1 py-0.5' : 'text-xs px-1.5 py-0.5';
  
  if (!enrichedAt) {
    return (
      <span className={`inline-flex items-center gap-1 text-purple-600 bg-purple-500/10 rounded ${sizeClasses} ${className}`}>
        <Sparkles className={size === 'sm' ? 'h-2.5 w-2.5' : 'h-3 w-3'} />
        AI
      </span>
    );
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className={`inline-flex items-center gap-1 text-purple-600 bg-purple-500/10 rounded ${sizeClasses} ${className}`}>
            <Sparkles className={size === 'sm' ? 'h-2.5 w-2.5' : 'h-3 w-3'} />
            AI
          </span>
        </TooltipTrigger>
        <TooltipContent>
          <p>AI-enriched on {format(new Date(enrichedAt), 'MMM d, yyyy')}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
